import type { BaseOptionType } from "antd/es/select"

/**
 * Options for a drop-down whose values a company manages in Settings.
 *
 * `held` is the value the record being edited carries. It survives the filter
 * even when retired, because dropping it makes the Select render a raw slug.
 * A lead list row carries the label where a workspace carries the value, so
 * both are matched.
 */
export function pickableOptions(
  options: BaseOptionType[] | undefined,
  held?: string | null
): BaseOptionType[] {
  return (options ?? []).filter(
    (option) =>
      // A backend that predates the flag serves neither true nor false.
      option?.is_active !== false ||
      (held != null && (option?.value === held || option?.label === held))
  )
}

/** Whether the selected option asks for its accompanying free-text note. */
export function optionRequiresDetail(
  value: string | null | undefined,
  options: BaseOptionType[] | undefined
): boolean {
  if (!value || !options?.length) return false
  return (
    options.find((option) => option?.value === value)?.requires_detail === true
  )
}
